import { START_SALE_SUCCESS } from '../constants/ActionTypes';

export default function timeouts(state = {}, action) {
  let nextState = {};
  let hasNewState = null;

  hasNewState = false;

  // put actions that TRIGGER the _TIMEOUT
  [START_SALE_SUCCESS].forEach(type => {
    if (action.type === type) {
      nextState = Object.assign({}, state, {
        [action.type]: {
          timeout: action.timeout,
          meta: action.meta
        }
      });
      hasNewState = true;
    } else if (state[type] != null && state[type].timeout != null) {
      hasNewState = true;
      clearTimeout(state[type].timeout);
      Object.assign(nextState, state, { [type]: null });
    }
  });

  if (hasNewState) {
    return nextState;
  }

  return state;
}
